import { isDefined } from "./utils";

export function compactObject(
  object: Record<string, unknown>
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(object)
      .filter(([_, v]) => isDefined(v))
      .map(([k, v]) => [
        k,
        v === Object(v) ? compactObject(v as Record<string, unknown>) : v,
      ])
  );
}
